import { AbstractService } from "./abstract.service";
import FileDownload from "js-file-download";
import moment from "moment";

export class DebtService extends AbstractService {
  static get entity() {
    return "proxy-gateway/gw-core/debt-note";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getDebtDetail(params) {
    try {
      const response = await this.callApi().get(`${this.entity}/${params}`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async update(params) {
    const response = await this.callApi().put(`${this.entity}/${params.id}`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
  }

  static async getDebtAccomplished(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/get-list`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getDebtAccomplishedv2(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/search`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async addNewDebt(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = await this.callApi().post(`${this.entity}/`, params);
      throw message;
    }
  }

  static async searchDebt(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/get-list`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async addNewPay(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/${params.id}/record-repayment`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getHistoryPay(params) {
    try {
      const response = await this.callApi().get(`${this.entity}/${params}/repayments`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async exportData(params) {
    try {
      const response = await await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/imexport/api/debt-note/export`, params, {responseType: 'blob'}
      )

      FileDownload(response.data, 'Report-DebtNote' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')

      return this.responseWrapper(response, response);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async importData(params) {
    try {
      const response = await await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/imexport/api/debt-note/import`, params
      )
      return this.responseWrapper(response, response);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
